/**
 * Configures administration routes for a resource type.
 *
 * @type {ngConfig}
 * @see TmrAdminResourceRoutes
 */
let tmrAdminResourceConfig = /*@ngInject*/ (
  TmrRoutesProvider,
  TmrAdminResourceRoutesProvider
) =>
  TmrRoutesProvider.afterConfigCallbacks.push(routes =>
    TmrAdminResourceRoutesProvider.setupRoutes(routes)
  )

export { tmrAdminResourceConfig as config }
